module.exports = __webpack_public_path__ + "static/media/whois.ef3ec1d2.jpg";